const constantRoutes = [{
        path: "/",
        redirect: "/meetingManages"
    },
    {
        path: '/',
        name: "Home",
        redirect: "/meetingManages",
        component: () => import('../components/layout/Home.vue'),
        children: [{
                path: '/meetingManages',
                component: () => import('../page/meetingManages'),
                meta: {
                    title: '会议管理'
                }
            },
            {
                path: "/personManager",
                component: () => import('../page/creditor'),
                meta: {
                    title: '人员管理'
                }
            },
			{
			    path: "/enterMeeting",
			    component: () => import('../page/enterMeeting'),
			    meta: {
			        title: '进入会议'
			    }
			},
            {
                path: "/liveBroadcast",
                component: () => import('../page/liveBroadcast'),
                meta: {
                    title: '会议直播'
                }
            },
            // {
            //     path: "/voting",
            //     component: () => import('../page/meetingManages/components/vote'),
            //     meta: {
            //         title: '投票表决'
            //     }
            // }
        ]
    },
    {
        path: "/login",
        name: 'login',
        component: () => import('../page/login'),
        meta: {
            title: '网络会议参会平台'
        }
    }
]
export default constantRoutes